export default 'npm install --save jsonwebtoken';
